import AzureExtractFeed from './AzureExtractFeed'

export default function TitoFeed() {
  return <AzureExtractFeed feedId="tito" />
}
